import { render, staticRenderFns } from "./PatientPortrait.vue?vue&type=template&id=0c9f6f93&scoped=true&"
import script from "./PatientPortrait.vue?vue&type=script&lang=js&"
export * from "./PatientPortrait.vue?vue&type=script&lang=js&"
import style0 from "./PatientPortrait.vue?vue&type=style&index=0&id=0c9f6f93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f6f93",
  null
  
)

export default component.exports